import React, {Component, useState} from "react";

export default ({ question, index, selectAnswer }) => {

    const [selectedAnswerId, setSelectedAnswerId] = useState(0);


    return <div className="question">
        <div className="question__inner">
            <h4 className="question__number">{index}.</h4>
            <h3 className="question__question">{question.title}</h3>
            <div className="question__options">
                <ul>
                    {question.answers.map((answer)=> {

                        let className = 'btn btn--blue--hollow btn--blue';
                        if (answer.id === selectedAnswerId) {
                            className = 'btn btn--blue--solid btn--blue';
                        }

                        return <li key={'ans__' + answer.id}>
                            <a className={className}
                               onClick={(e) => {
                                   e.preventDefault();
                                   selectAnswer(answer);
                                   setSelectedAnswerId(answer.id);
                                   return false;
                               }}>
                                {answer.title}
                            </a>
                        </li>
                    })}
                </ul>
            </div>
        </div>
    </div>;
}
